const WordPressPrompt = ({onClose, isWoo = false}) => { 

    const wordpressUrl = () => {
        window.open('https://wordpress.org/plugins/chirpyweb/');
    }

    return <> 
        <div className="modal fade show modal-center" tabindex="-1">
            <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div style={{borderBottom: 'none'}} className="modal-header d-flex align-items-center">
                    <label className="form-label text-dark h4 medium mb-0 word-wrap">Install using Wordpress</label>
                    <i onClick={() => onClose()} className="btn btn-neutral icon icon-close"></i>
                </div>
                <div className="modal-body">
                    <div>
                        <ol>
                            <li>
                                From your Wordpress dashboard, navigate to <b>{'Plugins > Add New'}</b> and search for ChirpyWeb. Once
                                presented with the plugin, click on <b>Install Now</b> followed by <b>Activate</b> 
                            </li>
                            <li>
                                Navigate to your <b>{'ChirpyWeb Account > Websites > How to Install : Website Key'}</b>. Copy the Website Id to your Clipboard
                            </li>
                            <li>
                                Open the newly installed ChirpyWeb Plugin on your Wordpress account. Enter the copied Website Id in the input box
                                and click on Save. 
                            </li>
                            <li>
                                Once Saved, visit your website you will be able to see opt-in prompt.
                            </li>
                            {
                                isWoo && <div className="mt-2">Note: Kindly enable WooCommerce from your admin panel to enable WooCommerce Automation features.</div>
                        
                            }
                        </ol>
                    </div>
                    <div className="d-flex justify-content-center">
                        <button className="btn btn-primary" onClick ={wordpressUrl}>Download Plugin <i className="icon icon-edit-inline mr-1"></i></button>    
                    </div>                 
                </div>
            </div>
            </div>
        </div>
        <div className="modal-backdrop fade show"></div>
    </>

}
export default WordPressPrompt;